import React from 'react'

export const UnitedAnesthesiaFooter = () => {
	return (
		<>
			<footer className="footer-7 text-center-xs bg--dark">
				<div className="container">
					<div className="row">
						<div className="col-sm-6" style={{marginRight: '0px', paddingRight: '0px'}}>
							<div className="footer-stack-copyright">
								COPYRIGHT 2025 UNITED ANESTHESIA ASSOCIATES, INC. ALL RIGHTS RESERVED. United Anesthesia, a GHR Healthcare company, is an Equal Opportunity Employer.
							</div>
						</div>
						<div className="col-sm-6 text-right text-center-xs">
							<ul className="social-list list-inline list--hover stack-footer-social">
								<li>
									<a href="https://www.facebook.com/UnitedAnesthesia/" title="United Anesthesia Facebook Page" target="_blank">
										<i className="socicon icon--xs socicon-facebook"></i>
									</a>
								</li>
								<li>
									<a href="https://twitter.com/UnitedAnesthesi" title="United Anesthesia Twitter Page" target="_blank">
										<i className="socicon icon--xs socicon-twitter"></i>
									</a>
								</li>
								<li>
									<a href="https://www.linkedin.com/company/united-anesthesia/" title="United Anesthesia Linkedin Page" target="_blank">
										<i className="socicon icon--xs socicon-linkedin"></i>
									</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</footer>
		</>
	)
}
